import React, { type ReactNode, type FC, type PropsWithChildren } from 'react';

import { theme } from '@lucid/theme';

import ThemeProvider from '../../theme-provider/theme-provider';
import buttons from './buttons';
import type { Lucid } from '../../../types/types';

interface UnifyCtaButtonsProps {
  children: ReactNode;
  product: Lucid.Product.Sites;
}

const ABTestThemeProviderUnifyCtaButtons: FC<PropsWithChildren<UnifyCtaButtonsProps>> = ({ children, product }) => {
  const alternativeTheme = Object.assign({}, theme);
  alternativeTheme.buttons = buttons as Lucid.Theme['buttons'];

  return (
    <ThemeProvider product={product} theme={alternativeTheme}>
      {children}
    </ThemeProvider>
  );
};

export default ABTestThemeProviderUnifyCtaButtons;
